<div class="credibility">
  <div style="display: flex">
    <h1>Credibility</h1>
    <mat-icon
      class="info-icon"
      matTooltip="Credibility within the organization affects the impact of certain actions. Actions taken at the right time can increase credibility, while poorly timed actions can reduce it.​​"
      matTooltipPosition="above"
    >
      info
    </mat-icon>
  </div>
  <div class="progress">
    <label for="rating">{{ credibility }} of 10</label>
    <div
      *ngFor="let bar of progressCredibility; let i = index"
      class="progress-wrapper"
    >
      <!-- Progress bar -->
      <div
        class="progressBar"
        [ngClass]="{
          'pink-bar': i < credibility
        }"
      ></div>
    </div>
  </div>
</div>
